import * as React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DialogActions from "@material-ui/core/DialogActions";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import Modal from "../Modal";
import Buttons from "../DialogButtons";

const useStyles = makeStyles((theme) => ({
  footer: { display: "flex", justifyContent: "flex-start" },
}));

export default function DeleteBank(props) {
  const { open, onSubmit, handleClose, bank } = props;
  const classes = useStyles();
  return (
    <Modal
      open={open}
      onClose={handleClose}
      width={500}
      icon={NotificationImportantIcon}
      iconColor="draft"
      iconMarginLeft={-40}
      title={<b>Delete Bank Account: {bank.account}</b>}
      text={
        <>
          Do you want to delete bank account {bank.account}? Don't worry, you
          can always reconnect a bank account later.
        </>
      }
    >
      <DialogActions className={classes.footer}>
        <Buttons
          onSubmit={onSubmit}
          handleClose={handleClose}
          buttonName="Delete"
          submittingText="Deleting bank account"
        />
      </DialogActions>
    </Modal>
  );
}
